import { EEntityType } from '@sharedInterfaces/globalEnums';
import type { EDashboardWidgetTypes, IDashboardDTO, TWidgetConfig } from '@sharedInterfaces/IDashboard';
import type { Layout } from 'react-grid-layout';

import { Entity, entityFieldsGQL } from './Entity';

export const dashboardGQL = `{
            id
            title
            description
            widgets
            layout
            version
            ${entityFieldsGQL}
          }`;
export default class Dashboard extends Entity {
    declare id: string;
    type: EEntityType = EEntityType.DASHBOARD;
    description: string;
    layout: Layout[];
    widgets: TWidgetConfig<EDashboardWidgetTypes>[];
    constructor(obj: IDashboardDTO) {
        super(obj);
        this.description = obj.description;
        this.layout = JSON.parse(obj.layout);
        this.widgets = JSON.parse(obj.widgets);
    }

    async delete() {
        throw new Error('Not implemented');
        // const { default: deleteDashboard } = await import("@src/APIs/graphQl/Dashboard/deleteDashboard");
        // return deleteDashboard(this.id);
    }
}
